import PropTypes from 'prop-types';
import officeLocationShape from './officeLocationShape';

export default PropTypes.shape({
	officeID: PropTypes.string,
	partnerID: PropTypes.string.isRequired,
	compliance: PropTypes.bool.isRequired,
	isComplianceParent: PropTypes.bool.isRequired,
	disclaimer: PropTypes.string,
	emailMarketing: PropTypes.bool.isRequired,
	socialMarketing: PropTypes.bool.isRequired,
	isFirmBrandingEnabled: PropTypes.bool.isRequired,
	campaignAutomation: PropTypes.bool.isRequired,
	videoDownload: PropTypes.bool.isRequired,
	complianceDownload: PropTypes.bool.isRequired,
	landingPages: PropTypes.bool.isRequired,
	firmName: PropTypes.string,
	phone: PropTypes.string,
	email: PropTypes.string,
	website: PropTypes.string,
	facebook: PropTypes.string,
	twitter: PropTypes.string,
	linkedin: PropTypes.string,
	createDate: PropTypes.instanceOf(Date).isRequired,
	modifyDate: PropTypes.instanceOf(Date).isRequired,
	locations: PropTypes.arrayOf(officeLocationShape).isRequired
});